// src/routes/PrivateRoute.tsx
import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

interface PrivateRouteProps {
  children: ReactNode
  allowedRoles?: string[]
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { auth } = useAuth()

  if (auth.loading) {
    return null // or <LoadingSpinner />
  }

  if (!auth.token) {
    return <Navigate to="/login" />
  }


  const userRole = auth.user?.role

  if (allowedRoles && (!userRole || !allowedRoles.includes(userRole))) {
    return <Navigate to={userRole === 'super admin' ? '/admin' : '/dashboard'} />
  }

  return <>{children}</>
}

export default PrivateRoute
